import { render } from "./AlterarStatus.vue?vue&type=template&id=256a3df8"
import script from "./AlterarStatus.vue?vue&type=script&lang=ts"
export * from "./AlterarStatus.vue?vue&type=script&lang=ts"
script.render = render

export default script